import { createSelector } from 'reselect';
import getShopPaymentMethodsDivided from './getShopPaymentMethodsDivided';
import { OFFLINE } from './constants';
import sortPaymentMethodsByName from './utils/sortPaymentMethodsByName';

const getShopOfflinePaymentMethods = createSelector(
  getShopPaymentMethodsDivided,
  methods => methods[OFFLINE].sort(sortPaymentMethodsByName),
);

export default getShopOfflinePaymentMethods;
